import { adminHttpClient } from '../../commons/adminHttpClient'

export enum NotificationType {
  ReimbursementsDueForCurrentYear = 0,
  ReimbursementsDueForPreviousYear = 1,
  ReimbursementsRequestForCurrentYear = 2,
  ReimbursementsRequestForPreviousYear = 3,
  W2Report = 4,
  C1095Report = 5,
  PopUpForPremiumPlus,
}

export type NotificationItem = {
  notificationId: string
  notificationType: NotificationType
  name: string
  reimbursementAmount?: number
  userCount?: number
  reimbursementsRequestCount: number
  planPeriodId: string
  planPeriodStartDate: string
}

export const getNotifications = (): Promise<NotificationItem[]> => {
  return adminHttpClient.get('/AdminDashboard/Notifications')
}

export default getNotifications
